/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScoreboardBreakdownEmployeeScores = {
    properties: {
        employeeId: {
    type: 'number',
    isRequired: true,
},
        employeeName: {
    type: 'string',
    isRequired: true,
},
        scores: {
    type: 'array',
    contains: {
    type: 'number',
},
    isRequired: true,
},
    },
};